"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toTurkishLowerCase;
/**
 *  Converts a string to turkish lowercase.
 *
 * e.g.: `ValiKonağı Şubesi` -> `valikonağı şubesi`
 *
 * @param {string} str String to convert to turkish lowercase
 * @returns {string} Same string but lowercased
 */
function toTurkishLowerCase(str) {
  var uppperIRegExp1 = /I/g;
  var upperIRegExp2 = /İ/g;
  if (str) return str.replace(uppperIRegExp1, 'ı').replace(upperIRegExp2, 'i').toLowerCase();
  return str;
}